// Shared by every page through navigation.js. The head bootstrap handles first paint.
import { t } from '../i18n/index.js';
const storageKey = 'theme';
let initialized = false;
let preference = null;

function validTheme(value) {
    return value === 'light' || value === 'dark' ? value : null;
}

function savedTheme() {
    try { return validTheme(localStorage.getItem(storageKey)); } catch (_) { return null; }
}

function applyTheme(theme) {
    const isDark = theme === 'dark';
    document.documentElement.classList.add('an-theme-changing');
    document.documentElement.dataset.theme = theme;
    document.documentElement.classList.toggle('dark', isDark);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = isDark ? '#0d0c12' : '#faf5f0';
    document.querySelectorAll('[data-theme-toggle]').forEach(button => {
        button.setAttribute('aria-pressed', String(isDark));
        button.title = t(isDark ? 'theme.switchToLight' : 'theme.switchToDark');
    });
    window.dispatchEvent(new CustomEvent('an:themechange', { detail: { theme } }));
    requestAnimationFrame(() => requestAnimationFrame(() => document.documentElement.classList.remove('an-theme-changing')));
}

export function toggleTheme() {
    preference = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem(storageKey, preference); } catch (_) {}
    applyTheme(preference);
}

export function initTheme() {
    if (initialized) return;
    initialized = true;
    const system = window.matchMedia('(prefers-color-scheme: dark)');
    preference = savedTheme();
    const resolved = () => preference || (system.matches ? 'dark' : 'light');
    applyTheme(resolved());
    window.addEventListener('an:languagechange', () => applyTheme(document.documentElement.dataset.theme));
    document.querySelectorAll('[data-theme-toggle]').forEach(button => button.addEventListener('click', toggleTheme));
    system.addEventListener('change', () => { if (!preference) applyTheme(resolved()); });
    window.addEventListener('storage', event => {
        if (event.key !== storageKey && event.key !== null) return;
        preference = validTheme(event.newValue);
        applyTheme(resolved());
    });
}

export default { initTheme, toggleTheme };
